export interface GalleryImage {
  small?: string;
  medium?: string;
  big?: string;
}
